/**
 * Drepturile de acces sunt flaguri booleene pe utilizator. Regulile sunt
 * definite o singura data aici, pentru ca sunt folosite din trei locuri care
 * nu impart acelasi context: garda de rutare (citeste direct din
 * localStorage, inainte ca store-ul sa fie populat), sidebar-ul si view-urile.
 */
export interface AdminUser {
    isAdmin?: boolean;
    hasStockAccess?: boolean;
    hasReportsAccess?: boolean;
    hasContractsOnlyAccess?: boolean;
    hasBlogOnlyAccess?: boolean;
}

/** Utilizatorul salvat de flow-ul de login in localStorage. */
export function storedUser(): AdminUser | undefined {
    try {
        const raw = localStorage.getItem('hud');
        return raw ? JSON.parse(raw) : undefined;
    } catch (e) {
        // Date corupte in localStorage - tratam ca "nelogat".
        return undefined;
    }
}

/** Cine poate deschide zona de Stocuri si poate scana etichetele. */
export function canAccessStock(user?: AdminUser): boolean {
    return !!user && (!!user.isAdmin || !!user.hasStockAccess);
}

/** Cont de gestionar de depozit: are voie doar in zona de Stocuri. */
export function isStockOnly(user?: AdminUser): boolean {
    return !!user && !!user.hasStockAccess && !user.isAdmin;
}

/** Meniul complet (licitatii, utilizatori, certificate etc.). */
export function canSeeGeneralMenu(user?: AdminUser): boolean {
    return (
        !!user &&
        !user.hasContractsOnlyAccess &&
        !user.hasBlogOnlyAccess &&
        !isStockOnly(user)
    );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/access.ts